<template>
  <ImportDuLieu />
</template>

<script>
import ImportDuLieu from "@/components/pages/quan-tri-he-thong/import/ImportDuLieu";
import { setBreadcrumb } from "@/utils/commonUtils";
export default {
  name: "TrangImport",
  components: {
    ImportDuLieu,
  },
  created() {
    setBreadcrumb(
      `Import dữ liệu hệ thống`
    );
  },
};
</script>


